export function validInstanceName(v: string) {
  // trim suffix first
  const name = (v || "").replace(/-(\d+)$/, "");

  // 此规则暂时不使用了，产品于 2023年10月13日 在“kce2.0控制台测试支持”群中确定改为使用 1.0 的规则，此处注释是为了防止以后又使用
  // return /^[A-Za-z][A-Za-z\d._-]{1,63}$/.test(name)
  //   ? true
  //   : "2-64个字符，支持英文，数字，以及特殊字符“.”、“-”、“_”，必须以英文开头";

  // 2025年确认Q1，不再使用 kce1.0 的规则
  // kce1.0 中的 '2-64check' 规则
  // return /^[0-9a-zA-Z\u4e00-\u9fa5-,.!$^*()%#&+/:;<=>[\]_`{|}~]{2,64}$/.test(name)
  //   ? true
  //   : "2-64个字符，支持中文，英文，数字，以及特殊字符-,.!$^*()%#&+/:;<=>[]_`{|}~";

  return /^[0-9a-zA-Z\u4e00-\u9fa5\-_]{2,64}$/.test(name)
    ? true
    : "2-64个字符，支持中文，英文，数字，以及特殊字符-_";
}
